import { useState, useEffect } from 'react'

function useKeyPress({ targetKey, ref, preventDefault = false }) {
  const currentRef = ref.current
  const [keyPressed, setKeyPressed] = useState(false)

  useEffect(() => {
    function downHandler(e) {
      if (e.key === targetKey) {
        if (preventDefault) e.preventDefault()
        setKeyPressed(true)
      }
    }

    function upHandler(e) {
      if (e.key === targetKey) {
        if (preventDefault) e.preventDefault()
        setKeyPressed(false)
      }
    }

    currentRef?.addEventListener('keydown', downHandler)
    currentRef?.addEventListener('keyup', upHandler)

    return () => {
      currentRef?.removeEventListener('keydown', downHandler)
      currentRef?.removeEventListener('keyup', upHandler)
    }
  }, [currentRef, targetKey, preventDefault])
  return keyPressed
}

export default useKeyPress
